import APIClient from '@/shared/http/clients/api'

const resourceName = 'REGroupImageArquivo'
const APIBaseURLRealEstate = process.env.APIBaseURLRealEstate

const RemoveImgArquivoGroup = (groupimagearquivoid, data = {}, config = {}) => APIClient.delete(`${APIBaseURLRealEstate}/${resourceName}/RemoveImgArquivoGroup/${groupimagearquivoid}`, data, config)

const GroupImageArquivoRepository = {
  RemoveImgArquivoGroup

}

export default GroupImageArquivoRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/realestate/groupimagearquivo.js